import { App } from './app';
import { TripteaseConfig } from './onboard/TripteaseConfig';
import MiniRollbar from './rollbar/MiniRollbar';
import { HotelGTagIdsInPublicApi } from '@paid-search/public-api/src/accountHotel/HotelGTagIdsInPublicApi';

export * from './onboard/TripteaseConfig';

declare const publicApiEndpoint: string;
declare const rollbarEnvironment: string;
declare const scriptVersion: string;

export const main = async (): Promise<void> => {
  const rollbar = new MiniRollbar(
    {
      accessToken: '1f7b07749b934844b0fab622b8dde57c',
      payload: {
        client: { javascript: { guess_uncaught_frames: true, source_map_enabled: true } },
        environment: rollbarEnvironment,
        scriptVersion,
      },
    },
    window,
  );

  const createGTag: () => void = new Function(`
        window.dataLayer = window.dataLayer || [];
        if (!window.gtag) {
          window.gtag = function () {
            window.dataLayer.push(arguments);
          };
        }
    `) as any as () => void;

  const hotelGTagIds = new HotelGTagIdsInPublicApi(publicApiEndpoint, window.fetch.bind(window));

  const app = new App(window, hotelGTagIds, createGTag, rollbar);

  window.addEventListener('message', async (event: MessageEvent<TripteaseConfig>) => {
    if (event.data && event.data.type === 'triptease.config' && event.data.payload) {
      await app.withIntegrationData(event.data.payload);
    }
  });

  if (window?.triptease?.config?.payload) {
    await app.withIntegrationData(window.triptease.config.payload);
  }
};

declare global {
  interface Window {
    gtag: Function;
    dataLayer: any[];
    triptease: {
      config: TripteaseConfig;
    };
  }
}

main();
